<template>
  <div class="tab-box">
    <div class="row">
      <div class="col-12">
        <p class="h6">Current Pools</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p v-if="groupPoolTypes && groupPoolTypes.length > 0">
          <span v-for="licenseType in groupPoolTypes"
            :key="licenseType.id"
            class="badge badge-info license-badge">
            {{ productName(licenseType) }}
          </span>
        </p>
        <p v-else class="text-center"><small>No pools found for this group.</small></p>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <p class="h6">Add New</p>
      </div>
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <select-item :validator="$v.selectedType"
            :items="selectableLicenseTypes"
            placeholder="Select a License Type"
            placeholderEmpty="No license types available"
            :isLoading="isLoadingOptions" />
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isAdding"
          :disabled="!selectableLicenseTypes || selectableLicenseTypes.length <= 0"
          @click.native.prevent="addPool">
          Add
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import SelectItem from '../../components/Inputs/SelectItem.vue';
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import ziperase from '../../services/ziperase';

export default {
  name: 'AddPoolsForm',
  components: {
    SelectItem
  },
  props: {
    group: Object
  },
  data() {
    return {
      selectedType: "",
      isAdding: false,
      isLoadingOptions: false,
      licenseTypes: [],
      addedPools: []
    };
  },
  validations: {
    selectedType: { required }
  },
  created() {
    this.fetchLicenseTypes();
    this.$store.dispatch('product/fetchProducts');
  },
  methods: {
    async fetchLicenseTypes() {
      try {
        this.isLoadingOptions = true;
        let response = null;

        if (this.isSuperUser || this.isStaffUser) {
          response = await ziperase.fetchLicenseTypes();
        } else if (
          // Allow partner superusers to any pool type that their organization has access to
          // (Only for the root group)
          this.isPartner &&
          !this.selectedOrganization.id != this.user.organization.id &&
          this.selectedOrganization.root_group.id == this.group.id
        ) {
          response = await ziperase.fetchOrganizationLicenseTypes(this.user.organization.id);
        } else {
          response = await ziperase.fetchGroupLicenseTypes(this.group.id);
        }

        this.licenseTypes = response.data;
      } catch (error) {
        notify().error('Failed to retrieve license types.');
      }
      this.isLoadingOptions = false;
    },
    async addPool() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please select a license type.');
        return;
      }

      this.isAdding = true;
      try {
        const success = await this.$store.dispatch('licensePool/createPool', {
          license_type_id: this.selectedType.id,
          group_id: this.group.id
        });

        if (success) {
          this.addedPools.push(this.selectedType);
          this.$emit('hasUpdate');
          this.resetForm();
        }
      } catch (err) {
        notify().error('Failed to add pool.');
      }
      this.isAdding = false;
    },
    resetForm() {
      this.selectedType = "";
      this.$v.$reset();
    },
    productName(licenseType) {
      let name = "";
      if (this.productMap[licenseType.product_id]) {
        name = `${this.productMap[licenseType.product_id].name}: `;
      } else if (licenseType.product && licenseType.product.name) {
        name = `${licenseType.product.name}: `;
      }
      return `${name}${licenseType.name}`;
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'isSuperUser', 'isStaffUser', 'isPartner']),
    ...mapGetters('product', ['productMap']),
    ...mapGetters('organization', ['selectedOrganization']),
    selectableLicenseTypes() {
      let types = this.licenseTypes || [];

      return types.filter(type => {
        return !this.groupPoolTypeIds.includes(type.id);
      }).map(type => {
        return {
          id: type.id,
          name: this.productName(type)
        };
      });
    },
    groupPoolTypes() {
      let pools = [];
      if (this.group && this.group.pools && this.group.pools.length > 0) {
        pools = this.group.pools.map(pool => {
          return pool.license_type;
        })
      }
      return pools.concat(this.addedPools);
    },
    groupPoolTypeIds() {
      return this.groupPoolTypes.map(poolType => {
        return poolType.id;
      });
    }
  }
};
</script>

<style scoped>
.license-badge {
  margin-right: 5px;
}
</style>
